export const PRECISION = {
    SECOND: 'seconds',
    MINUTE: 'minutes',
    HOUR: 'hours',
    DAY: 'days',
    MONTH: 'months',
    YEAR: 'years',
}
